import { pushDataObject } from '../../tracker/data-layer';
import { getItemsJoinedByPipe } from '../../utils';

import { type PushViewItemProps } from './types';

export const pushViewItem = (props: Readonly<PushViewItemProps>) => {
  const { item, hasBuyBox, isAvailable } = props;

  const category = item.categoryTree ? item.categoryTree.split('/') : [];
  const variants = getItemsJoinedByPipe(item.variants ? item.variants : []);

  pushDataObject({
    _clear: true,
    event: 'view_item',
    items: [
      {
        id: item.id,
        bind_id: item.bindId || undefined,
        name: item.name,
        type: item.type,
        price: item.price,
        discount: item.discount || undefined,
        discount_type: item.discountType || undefined,
        brand: item.brand,
        category: category[0] || undefined,
        category2: category[1] || undefined,
        category3: category[2] || undefined,
        category4: category[3] || undefined,
        category5: category[4] || undefined,
        variant: variants,
        seller: item.seller,
        quantity: item.quantity,
        box_unit: item.box?.unit || undefined,
        price_box: item.box?.price || undefined,
        quantity_box: item.box?.quantity || undefined,
      },
    ],
    has_buy_box: hasBuyBox ?? undefined,
    is_available: isAvailable ?? undefined,
  });
};
